$(document).ready(function(){
    $('.side-cart-open').on('click', function(){
        $('.jl-side-cart').addClass('open');
        $('body').addClass('scroll-hidden')
    })
    $(document).on('click','.side-cart-close',function(e){
        $('.jl-side-cart').removeClass('open');
        $('body').removeClass('scroll-hidden')
    })
    $('.you-may-also-like-slider-cart').slick({
        dots: false,
        infinite: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/2674/6290/files/icon-left-arrow.svg?v=1698987956" alt="Slider Arrow " loading="lazy" /></button>',
        nextArrow: '<button type="button" class="slick-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/2674/6290/files/icon-right-arrow.svg?v=1698987957" alt="Slider Arrow " loading="lazy" /></button>',
    });
});